import CustomerQuoteView from "./CustomerQuoteView";
import ConfirmationQuote from "../confirmation/ConfirmationQuote";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  getQuoteConfirmDetailsAction,
  setUpdateQuoteConfirmAction,
} from "../../../store/reducers/customerSlice";

const CustomQuoteConfirm = ({ leadDetails }: any) => {
  const dispatch = useDispatch();
  const { isCustomerQuoteUpdated } = useSelector(
    (state: any) => state.customer,
  );
  console.log("leadDetails in CustomQuoteConfirm", leadDetails);
  useEffect(() => {
    dispatch(
      getQuoteConfirmDetailsAction({ leadId: leadDetails?.generated_id }),
    );
  }, [dispatch, leadDetails?.generated_id]);

  useEffect(() => {
    if (isCustomerQuoteUpdated) {
      dispatch(
        getQuoteConfirmDetailsAction({ leadId: leadDetails?.generated_id }),
      );
      dispatch(setUpdateQuoteConfirmAction(false));
    }
  }, [dispatch, isCustomerQuoteUpdated, leadDetails?.generated_id]);


  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 32,
      }}
    >
      {/* <ConfirmationQuote /> */}
      <CustomerQuoteView />
    </div>
  );
};

export default CustomQuoteConfirm;
